import { dispatchTrackingEventGA4 } from 'common/tracking/dispatchTrackingEventGA4';
import { Element } from 'common/types/tracking';

const Event = {
  View: 'cta-buttons_view',
  Click: 'cta-buttons_click',
};

export const dispatchCtaButtonsViewEvent = (
  buttonText: string,
  element: Element.Button | Element.Image = Element.Button
) => {
  dispatchTrackingEventGA4({
    event: Event.View,
    element,
    button_text: buttonText,
  });
};

export const dispatchCtaButtonsClickEvent = (
  buttonText: string,
  element: Element.Button | Element.Image
) => {
  dispatchTrackingEventGA4({
    event: Event.Click,
    element,
    button_text: buttonText,
  });
};
